import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const words = [
    "LEONARD TECHNOLOGY INC.",
    "MANAGED IT",
    "CYBERSECURITY",
    "CLOUD",
    "24/7 SUPPORT",
  ];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-16 md:py-24 border-y border-white/10 bg-[#050505] overflow-hidden"
    >
      <Marquee speed={45} gradient={false} className="overflow-hidden">
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter text-white px-8">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-[#00E5FF] glow-cyan mx-4" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
